import { DateTime } from 'luxon';

export function formatDate(date: string, format: string = 'DDD'): string {
    return DateTime
        .fromISO(date)
        .setLocale('en')
        .toFormat(format);
}

export function formatDateInterval(date: string, dateEnd?: string): string {
    if (!dateEnd) {
        return formatDate(date, 'MMMM d');
    }

    const startDate = DateTime.fromISO(date);
    const endDate = DateTime.fromISO(dateEnd);
    const endDateFormat = startDate.hasSame(endDate, 'month') ? 'd' : 'MMMM d';

    return `${startDate.toFormat('MMMM d')}–${endDate.toFormat(endDateFormat)}`;
}
